import { PylonInAppChatScript } from "./pylon";
import { GoogleTagManagerScript } from "./google-tag-manager";

export const AppScripts = () => (
  <>
    <PylonInAppChatScript />
    <GoogleTagManagerScript />
  </>
);
